import { handleInput } from "../../classes/functions"
import "./selectWithLabel.css";

export default function SelectWithLabel({ label, name, isRequired, state, setState, disabled, optionsList, isBoolean, optionPropertyToShow }){
    function checkBooleanLabel(option){
        if(option === "S"){
            return "Sim";
        }

        return "Não";
    }

    return (
        <div className="form__select">
            <label>{label}</label>{isRequired && <>&nbsp;<label className="required">*</label></>}<br />
            <select value={state} onChange={(e) => setState((prevState) => ({...prevState, [name]: e.target.value}))} disabled={disabled}>
                <option value="">Selecione</option>
                {!isBoolean 
                    ?
                        <>
                            {optionsList?.map((option, index) => (
                                <option key={index} value={option.id}>{option[optionPropertyToShow]}</option>
                            ))}
                        </>
                    :
                        <>
                            {optionsList?.map((option, index) => (
                                    <option key={index} value={option}>{checkBooleanLabel(option)}</option>
                            ))}
                        </>
                }
            </select>
        </div>
    )
}